import { StylesConfig } from "react-select";

export const customStyles: StylesConfig<any, false> = {
  control: (provided) => ({
    ...provided,
    background: "#fff",
    borderColor: "#E0E0E0",
    minHeight: "30px",
    height: "30px",
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 6px",
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
    color: "#9E9E9E",
    fontFamily: "Open Sans",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
};

export const customMultiSelectStyles: StylesConfig<any, true> = {
  control: (provided) => ({
    ...provided,
    background: "#fff",
    borderColor: "#E0E0E0",
    minHeight: "30px",
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 6px",
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: "11px",
    fontFamily: "Open Sans",
    height: "20px",
    margin: "2px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: "11px",
    fontFamily: "Open Sans",
    padding: "2px 4px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    fontSize: "11px",
    padding: "2px 4px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
    color: "#9E9E9E",
    fontFamily: "Open Sans",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "14px",
    fontFamily: "Open Sans",
  }),
};